module.exports = __webpack_public_path__ + "static/media/(000123).0445c50d.jpg";